import React from 'react'

import { useCall } from '../hooks/useCall'
import { useSelector } from 'react-redux'

import { Collapse, chakra, shouldForwardProp } from '@chakra-ui/react'
import { AnimatePresence, isValidMotionProp, motion } from 'framer-motion'

import { selectSideNavOpen } from '@/redux/ui/uiSlice'
import {
  CALL_CONTAINER_Z_INDEX,
  SIDE_BAR_WIDTH_CLOSED,
  SIDE_BAR_WIDTH_OPEN,
} from '@/styles/theme'

import { CallExpanded } from './CallExpanded'
import { CallMinimized } from './CallMinimized'

const MotionBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
})

export const CallContainer = () => {
  const isSideNavOpen = useSelector(selectSideNavOpen)
  const { isOpen, isExpanded, callStatus } = useCall()

  return (
    <AnimatePresence>
      {isOpen && (
        <MotionBox
          animate={{ x: 0, opacity: 1 }}
          as={motion.div}
          bg='white'
          borderBottomLeftRadius={isExpanded ? '16px' : '0px'}
          borderBottomRightRadius={isExpanded ? '16px' : '0px'}
          borderTopLeftRadius='16px'
          borderTopRightRadius='16px'
          bottom={0}
          exit={{ x: '-100%', opacity: 0 }}
          initial={{ x: '-100%', opacity: 0 }}
          key='CallContainer'
          left={!isSideNavOpen ? SIDE_BAR_WIDTH_CLOSED : SIDE_BAR_WIDTH_OPEN}
          ml='20px'
          p='20px'
          pos='fixed'
          shadow='0px 2px 5px 6px rgba(0, 0, 0, 0.1)'
          transition={{ ease: 'easeInOut', duration: '0.3' }}
          w='450px'
          zIndex={CALL_CONTAINER_Z_INDEX}
        >
          <Collapse endingHeight='680px' in={isExpanded} startingHeight='70px'>
            {isExpanded ? (
              <CallExpanded callStatus={callStatus} />
            ) : (
              <CallMinimized />
            )}
          </Collapse>
        </MotionBox>
      )}
    </AnimatePresence>
  )
}
